var React = require('react');

function NavIconsExperienceViews (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m17.69 16a4 4 0 0 1 -4-4 3.86 3.86 0 0 1 .18-1.17l.07-.22-.21-.1-.25-.14a2.58 2.58 0 0 0 -1.48-.37 2.89 2.89 0 0 0 -1.58.35l-.25.12-.22.1.07.23a4.05 4.05 0 0 1 .22 1.2 4 4 0 0 1 -7.87.64v-.22h-1.88v-1.05h1.86v-.21a4 4 0 0 1 6.68-2l.2.22.14.16.34-.17a4.14 4.14 0 0 1 2.29-.52 3.79 3.79 0 0 1 2.16.56l.35.18.14-.16.21-.23a4 4 0 0 1 6.67 2l.05.21h1.9v1.05h-1.85v.22a4 4 0 0 1 -1.11 2.16 3.91 3.91 0 0 1 -2.83 1.16zm0-6.76a2.81 2.81 0 0 0 -2.8 2.76v.18a2.8 2.8 0 1 0 2.79-3zm-11.42-.04a2.81 2.81 0 1 0 2 4.79 2.8 2.8 0 0 0 0-3.94 2.81 2.81 0 0 0 -2-.83z"}));
}

NavIconsExperienceViews.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = NavIconsExperienceViews;

NavIconsExperienceViews.default = NavIconsExperienceViews;
